import { render, staticRenderFns } from "./OverviewKpis.vue?vue&type=template&id=c806e1c4&scoped=true&"
import script from "./OverviewKpis.vue?vue&type=script&lang=js&"
export * from "./OverviewKpis.vue?vue&type=script&lang=js&"
import style0 from "./OverviewKpis.vue?vue&type=style&index=0&id=c806e1c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c806e1c4",
  null
  
)

export default component.exports